import { useEffect } from 'react';

// Bandeau de panne synchro Jira : chargé une fois à la connexion, indépendamment de la vue
// affichée (visible dès l'ouverture de l'appli, pas seulement en allant sur l'admin Jira).
export function useJiraSyncHealthLoading({ loadJiraSyncHealth, profile, session }) {
  useEffect(() => {
    if (session && profile && profile.role === 'manager') loadJiraSyncHealth();
  }, [session, profile]);
}
